<div class="overlay" [ngClass]="{ 'popup-drawer-half-size' : (width === 'half'),
'popup-drawer-full-size': (width !== 'half')}" *ngIf="openDrawer" (click)="showHideDrawer(drawerId)"></div>
<div class="popup-drawer" [id]="drawerId" [ngClass]="{ 'open' : openDrawer ,
 'popup-drawer-half-size' : (width === 'half') , 'popup-drawer-full-size': (width !== 'half'), 'popup-drawer-center': centerPosition}">
    <div *ngIf="!hideMinimizeBtn" class="center">
        <div class="line" (click)="drawerMinimized = !drawerMinimized;compareDrawer();"></div>
    </div>
    <ng-content *ngIf="!drawerMinimized"></ng-content>
</div>